export const LANDING = '/';
export const SIGN_IN = '/signin';
export const OVERVIEW = '/overview';
export const OVERVIEW1 = '/green';
export const OVERVIEW2 = '/blue';
export const OVERVIEW3 = '/orange';